<template>
  <form @submit.prevent="$emit('input', {from: fromTemp, to: toTemp})">
    <div class="tw-grid tw-grid-cols-5 tw-gap-8">
      <div class="tw-col-start-1">
        <button class="btn btn-block btn-link" type="button" @click="$emit('reset')">
          <i class="fa fa-sync"></i> Reset
        </button>
      </div>

      <div>
        <div class="dropdown">
          <button
              class="btn btn-block btn-white dropdown-toggle"
              style="border: 1px solid #ccc;"
              type="button"
              data-toggle="dropdown"
          >
            Set period... <span class="caret"></span>
          </button>

          <ul class="dropdown-menu">
            <li>
              <a href="#" @click.prevent="setThisYear">
                This Year
              </a>
              <a href="#" @click.prevent="setLastYear">
                Last Year
              </a>
              <a href="#" @click.prevent="setThisQuarter">
                This Quarter
              </a>
              <a href="#" @click.prevent="setLastQuarter">
                Last Quarter
              </a>
              <a href="#" @click.prevent="setThisMonth">
                This Month
              </a>
              <a href="#" @click.prevent="setLastMonth">
                Last Month
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <input v-model="fromTemp" class="form-control" type="month">
      </div>

      <div>
        <input v-model="toTemp" class="form-control" type="month">
      </div>

      <div>
        <button class="btn btn-black btn-block" type="submit">
          Show
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import DateWidget from '@/vendor/forms/FormGroups/Widgets/Date'
import moment from "moment/moment";

export default {
  components: {DateWidget},

  model: {
    prop: 'filters'
  },

  props: {
    filters: {
      required: true,
      type: Object
    },
  },

  watch: {
    filters() {
      this.fromTemp = this.filters.from
      this.toTemp = this.filters.to
    },
  },

  data() {
    return {
      fromTemp: this.filters.from,
      toTemp: this.filters.to,
    }
  },

  methods: {
    setThisYear() {
      this.$emit('input', {
        from: moment().startOf('year').format('YYYY-MM'),
        to: moment().endOf('year').format('YYYY-MM'),
      })
    },

    setLastYear() {
      this.$emit('input', {
        from: moment().subtract(1, 'year').startOf('year').format('YYYY-MM'),
        to: moment().subtract(1, 'year').endOf('year').format('YYYY-MM'),
      })
    },

    setThisQuarter() {
      this.$emit('input', {
        from: moment().startOf('quarter').format('YYYY-MM'),
        to: moment().endOf('quarter').format('YYYY-MM'),
      })
    },

    setLastQuarter() {
      this.$emit('input', {
        from: moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM'),
        to: moment().subtract(1, 'quarter').endOf('quarter').format('YYYY-MM'),
      })
    },

    setThisMonth() {
      this.$emit('input', {
        from: moment().startOf('month').format('YYYY-MM'),
        to: moment().endOf('month').format('YYYY-MM'),
      })
    },

    setLastMonth() {
      this.$emit('input', {
        from: moment().subtract(1, 'month').startOf('month').format('YYYY-MM'),
        to: moment().subtract(1, 'month').endOf('month').format('YYYY-MM'),
      })
    },
  }
}
</script>
